export const IPA_TOURNAMENT_PAYBILL = "522522";

export const TOURNAMENT_HOST_API = {
  listMine: "/api/tournaments/host/mine",
  dashboard: (tournamentNumber) => `/api/tournaments/host/${tournamentNumber}`,
  register: "/api/tournaments/register",
  automateFixtures: (tournamentNumber) =>
    `/api/tournaments/host/${tournamentNumber}/schedule/automate`,
  markServiceSlotTaken: (tournamentNumber) =>
    `/api/tournaments/host/${tournamentNumber}/service-slots/mark-taken`,
  updateServiceProvider: (tournamentNumber, entryId) =>
    `/api/tournaments/host/${tournamentNumber}/service-providers/${entryId}`,
};

export const TOURNAMENT_FANBASE_API = {
  list: "/api/tournaments/fanbase",
  detail: (tournamentNumber) => `/api/tournaments/fanbase/${tournamentNumber}`,
  registerPreview: (tournamentNumber) =>
    `/api/tournaments/fanbase/${tournamentNumber}/register/preview`,
  registerTeam: (tournamentNumber) =>
    `/api/tournaments/fanbase/${tournamentNumber}/register`,
  confirmTeamPayment: (tournamentNumber, registrationId) =>
    `/api/tournaments/fanbase/${tournamentNumber}/team-registrations/${registrationId}/confirm-payment`,
};

export const TOURNAMENT_STATUS_LABELS = {
  draft: "Draft",
  pending: "Pending review",
  published: "Published",
  ongoing: "Ongoing",
  ended: "Ended",
  cancelled: "Cancelled",
  completed: "Ended",
};

/** Prefer API display_status (ongoing / ended) over raw DB status. */
export function tournamentStatusLabel(itemOrStatus) {
  if (itemOrStatus && typeof itemOrStatus === "object") {
    const key = itemOrStatus.display_status || itemOrStatus.status || "";
    return TOURNAMENT_STATUS_LABELS[key] || key;
  }
  return TOURNAMENT_STATUS_LABELS[itemOrStatus] || itemOrStatus;
}

export function tournamentStatusClass(itemOrStatus) {
  if (itemOrStatus && typeof itemOrStatus === "object") {
    return itemOrStatus.display_status || itemOrStatus.status || "published";
  }
  return itemOrStatus || "published";
}

export const SERVICE_PROVIDER_LABELS = {
  sound: "Sound system",
  food: "Food services",
  emergency: "Emergency services",
};

export const REGISTRATION_STATUS_LABELS = {
  pending: "Pending",
  confirmed: "Confirmed",
  waitlisted: "Waitlisted",
  cancelled: "Cancelled",
};

export const PAYMENT_COLLECTION_LABELS = {
  ipa_paybill: "IPA Paybill",
  host_direct: "Host account",
  paybill: "IPA Paybill",
  custom: "Host account",
};

export const HOST_PAYMENT_PROVIDER_LABELS = {
  mpesa: "M-Pesa",
  airtel_money: "Airtel Money",
};
